import './App.css';

import { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import SettingsService from './Core/Services/SettingsService';
import PaymentStatus from './components/Completed/PaymentStatus';
import SelfStorageForm from './components/Base/SelfStorageForm';
import FinalizePayment from './components/FinalizePayment/FinalizePayment';
import { GlobalStateProvider } from './Core/GlobalState/Store';

const stripePromise = loadStripe(SettingsService.getStripePublicKey());

function App() {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isReAuthRequired, setIsReAuthRequired] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setIsSuccess(searchParams.get('success') === 'true');
    setIsReAuthRequired(searchParams.get('reauth') === 'true');
  }, []);

  return (
    <GlobalStateProvider>
      <div className="App max-w-[1230px] mx-auto ">
        <link
          rel="stylesheet"
          href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"
          integrity="sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY="
          crossorigin=""
        />
        <script
          src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"
          integrity="sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo="
          crossorigin=""
        ></script>
        {!isSuccess && !isReAuthRequired && <SelfStorageForm />}
        {isSuccess && !isReAuthRequired && (
          <Elements stripe={stripePromise}>
            <PaymentStatus />
          </Elements>
        )}
        {isReAuthRequired && <FinalizePayment />}
      </div>
    </GlobalStateProvider>
  );
}

export default App;
